import { useRouter } from "next/router";
import { divTexts } from "../../../../common/const/divTexts";
import { precautionData } from "../../../../common/data/precautionData";
import MultipleViewText from "../../../shared/MultipleViewText";
import styles from "../ModalContents.module.scss";

const Precaution: React.FC = () => {
  const router = useRouter();
  const {
    query: { ver, orgId, course },
  } = router;

  const isSmartphone = !navigator.userAgent.match(
    /(iPhone|iPod|Android.*Mobile)/i
  );

  const precaution = precautionData.filter((data) => {
    const { ver: verUrl, orgId: orgIdUrl, course: courseUrl } = data;

    if (ver === verUrl && orgId === orgIdUrl && course === courseUrl)
      return data;
  });

  if (!precaution.length) return null;

  const { textMVArray } = precaution[0];

  return (
    <div className={`${styles.modalInner}`}>
      <div className={styles.precaution}>
        {isSmartphone && (
          <div className="mb-3 font-bold text-red-500">
            <MultipleViewText text={divTexts?.当コンテンツはMV} />
          </div>
        )}
        {textMVArray?.map((text, i) => {
          return (
            <div key={text?.kanji + i}>
              <MultipleViewText text={text} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Precaution;
